import ModalBottom from "../../../../UI/ModalBottom";
import { ReactSVG } from "react-svg";
import Textarea from "../../../../UI/Textarea";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendMessageReport } from "../../../../../redux/action/messages/chat/chatAction";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import {
  getBaseDataInfoFromLocaleStorage,
  saveBaseDataInfoToLocaleStorage,
} from "../../../../../utils/base-data";
import { getBaseDataLawyer } from "../../../../../redux/action/baseData/baseAction";
import ToastCustom from "../../../../UI/ToastCustom";

const ReportModal = ({
  showModalReport,
  setShowModalReport,
  showingModalReport,
  setShowingModalReport,
  userId,
}) => {
  const [reportData, setReportData] = useState({
    title: "یک مورد را انتخاب کنید",
    desciption: "",
  });

  const [reportItem, setReportItem] = useState([]);
  const dispatch = useDispatch();
  const [cookies] = useCookies(["authToken"]);
  const navigate = useNavigate();

  const [showToast, setShowToast] = useState({
    show: false,
    type: "error",
    text: "",
  });

  useEffect(() => {
    getLinksDataFromBaseData();
  }, []);

  const getLinksDataFromBaseData = async () => {
    const baseData = getBaseDataInfoFromLocaleStorage();
    if (!baseData) {
      const data = await dispatch(await getBaseDataLawyer(cookies.authToken));
      if (data) {
        saveBaseDataInfoToLocaleStorage(data);
        setReportItem(data.config.terms_report);
      }
    } else {
      setReportItem(baseData.config.terms_report);
    }
  };

  const hideReportModal = () => {
    setShowingModalReport(false);
    setTimeout(() => {
      setShowModalReport(false);
    }, 300);

    document.body.classList.remove("modal-opened");
  };

  const updateReportField = (e, inputName) => {
    if (inputName === "desciption" && e.target.value.length > 500) return;
    setReportData({
      ...reportData,
      [inputName]: e.target.value,
    });
  };

  const sendMessage = async () => {
    if (reportData.title !== "یک مورد را انتخاب کنید") {
      const id = Math.random() * 209384 + "text-item";
      const createMessage = `گزارش تخلف کاربر با شماره کاربری ${userId} را میدهم زیرا : ${reportData.title} ، ${reportData.desciption}`;
      // add message to server
      const data = await dispatch(
        await sendMessageReport(192, createMessage, cookies.authToken, id)
      );
      if (data) {
        if (data.success) {
          setShowToast({
            show: true,
            type: "success",
            text: data.data.response,
          });
          setTimeout(() => {
            setShowToast({
              show: false,
              type: "error",
              text: "",
            });
            navigate("/messages");
            hideReportModal();
          }, 2000);
        } else {
          setShowToast({
            show: true,
            type: "error",
            text: data.data.response,
          });
          setTimeout(() => {
            setShowToast({
              show: false,
              type: "error",
              text: "",
            });
            hideReportModal();
          }, 2000);
        }
      }
    } else {
      setShowToast({
        show: true,
        type: "error",
        text: "یک نوع تخلف را برای کاربر مورد نظر انتخاب کنید !",
      });
      setTimeout(() => {
        setShowToast({
          show: false,
          type: "error",
          text: "",
        });
      }, 2000);
    }
  };

  return (
    <ModalBottom
      show={showModalReport}
      onSetShow={setShowModalReport}
      className="overflow-y-auto no-scrollbar h-full"
      showing={showingModalReport}
      onSetShowing={setShowingModalReport}
    >
      <div className="sticky top-0 left-0 flex flex-col bg-white w-full z-[1] border-b border-b-slate-200">
        <div className="py-2 bg-white z-[1] mb-2">
          <div className="mx-auto w-20 h-2 bg-gray-200 rounded-2xl"></div>
        </div>

        <div className="flex items-center justify-between gap-4 mb-4">
          <button
            onClick={hideReportModal}
            type="button"
            className="w-10 group"
          >
            <ReactSVG
              src={`${process.env.PUBLIC_URL}/assets/images/icons/back.svg`}
              className="w-5 text-gray-600 hover:text-primary duration-300 rotate-180 mr-1.5 group-disabled:text-gray-400 group-disabled:opacity-70"
            />
          </button>

          <button
            onClick={sendMessage}
            className="shadow-custom-sm shadow-primary/10 rounded-lg text-white bg-primary flex items-center justify-center gap-2 profile-btn outline outline-2 outline-primary/10 px-2 py-1"
          >
            ثبت
          </button>
        </div>
      </div>

      <div className="grid gap-8 mt-5">
        <div className="flex flex-col gap-2.5 group cursor-pointer">
          <label
            htmlFor="title"
            className="text-sm group-focus-within:text-primary duration-300 cursor-pointer text-gray-500"
          >
            نوع تخلف :
          </label>
          <div className="relative">
            <select
              name="title"
              value={reportData.title}
              id="title"
              className="py-3 pr-10 px-4 peer w-full focus:outline-none shadow-custom-md border border-gray-200/70 focus:!border-primary duration-300 transition-colors rounded-xl pl-16 appearance-none"
              onChange={(e) => updateReportField(e, "title")}
            >
              <option disabled>یک مورد را انتخاب کنید</option>
              {reportItem.map((item, index) => {
                return (
                  <option key={index} value={item}>
                    {item}
                  </option>
                );
              })}
            </select>

            <ReactSVG
              src={`${process.env.PUBLIC_URL}/assets/images/icons/exclamation.svg`}
              className={`w-5 h-5 text-primary absolute right-3 top-0 bottom-0 my-auto peer-focus:!text-primary duration-300`}
            />
          </div>
        </div>

        <Textarea
          id={"desciption"}
          label={"توضیحات"}
          max={500}
          icon={"folder"}
          type="text"
          className={"text-right"}
          value={reportData.desciption}
          onChange={(e) => updateReportField(e, "desciption")}
        />
      </div>

      {showToast.show && (
        <ToastCustom>
          <div className="flex items-center gap-2">
            <ReactSVG
              className={`${
                showToast.type === "error"
                  ? "text-rose-500/90"
                  : "text-green-600"
              } 4xm:w-8 w-6`}
              src={`${process.env.PUBLIC_URL}/assets/images/icons/tick.svg`}
            />
            {showToast.text}
          </div>
        </ToastCustom>
      )}
    </ModalBottom>
  );
};

export default ReportModal;
